/**
 * Validate a form's Open Dental imaging configuration before save.
 *
 * A form's ConfigData JSON carries formConfig.pdfCategory (Open Dental imaging
 * category DefNum) and formConfig.pdfFileName. When either is blank, patient
 * submissions never import into Open Dental, so both are required when saving
 * any form. formConfig.attachmentCategory stays optional and is never checked.
 *
 * @param {Object} formConfig - The formConfig object (may be null/undefined; treated as all-blank)
 * @returns {string[]} Human-readable labels of the missing required fields, in order:
 *   'Open Dental Imaging Category' (pdfCategory), 'PDF file name' (pdfFileName).
 *   Empty array when both are set.
 */
function getMissingOdImagingFields(formConfig) {
    const config = formConfig || {};
    const isBlank = (value) => value === null || value === undefined || String(value).trim() === '';

    const missing = [];
    if (isBlank(config.pdfCategory)) {
        missing.push('Open Dental Imaging Category');
    }
    if (isBlank(config.pdfFileName)) {
        missing.push('PDF file name');
    }
    return missing;
}

export { getMissingOdImagingFields };
